import PropTypes from 'prop-types';
import { HiPlus } from 'react-icons/hi2';

const LAYOUT_CLASSES = {
	grid: 'min-h-[200px]',
	list: 'py-8',
};

const CollectionCreatePlaceholder = ({ label, onClick, layout }) => (
	<button
		type="button"
		onClick={onClick}
		className={`flex items-center justify-center gap-1.5 rounded-card border border-dashed border-primary-300 bg-white text-sm text-primary-500 transition-colors hover:bg-primary-100 ${LAYOUT_CLASSES[layout]}`}
	>
		<HiPlus className="h-4 w-4" />
		{label}
	</button>
);

CollectionCreatePlaceholder.propTypes = {
	label: PropTypes.string.isRequired,
	onClick: PropTypes.func.isRequired,
	layout: PropTypes.oneOf(['grid', 'list']).isRequired,
};

export default CollectionCreatePlaceholder;
